import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateProductOrientation',
})
export class TranslateProductOrientationPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'upright_shorter':
        return 'Natural along';
      case 'upright_longer':
        return 'Natural across';
      case 'sideways_shorter':
        return 'Long side along';
      case 'sideways_longer':
        return 'Long side across';
      case 'flat_shorter':
        return 'Short side along';
      case 'flat_longer':
        return 'Short side across';
      default:
        return value;
    }
  }
}
